import { render, staticRenderFns } from "./EditModeTopBanner.vue?vue&type=template&id=3cb5bf99&scoped=true"
var script = {}
import style0 from "./EditModeTopBanner.vue?vue&type=style&index=0&id=3cb5bf99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5bf99",
  null
  
)

export default component.exports